module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "HelpPage"
  }, [_c('header-component'), _vm._v(" "), _c('help-article'), _vm._v(" "), _c('help-contact'), _vm._v(" "), _c('help-info'), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-03c09453", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03c09453"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Help.vue
// module id = 455
// module chunks = 3